import Api from '@/services/Api'

export default {
  getConfig() {
    return Api().get('cutoff/config')
  },

  getOrders(event, country) {
    return Api().get('cutoff/orders', { params: { event, country } })
  }
}
